import { useState } from "react";
import { Link } from "react-router-dom";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Input } from "@/components/ui/input";
import { PageHeader, SimpleSelect, Kpi, ExportButton, Empty, Table, Th, Td, Tr } from "@/components/common";
import { Belt } from "@/components/Belt";
import { useApi } from "@/lib/useApi";
import { useAuth } from "@/context/AuthContext";
import { addDays, dt, todayISO } from "@/lib/fmt";

export default function Attendance() {
  const { user } = useAuth();
  const [start, setStart] = useState(addDays(todayISO(), -29));
  const [end, setEnd] = useState(todayISO());
  const [group, setGroup] = useState("day");
  const [r] = useApi(`/attendance/report?start=${start}&end=${end}&group=${group}`);
  return (
    <div>
      <PageHeader eyebrow="Relatórios" title="Frequência">
        <Input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="w-40" data-testid="att-start-input" />
        <Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} className="w-40" data-testid="att-end-input" />
        <SimpleSelect value={group} onChange={setGroup} className="w-36" testid="att-group-select"
          options={[{ value: "day", label: "Por dia" }, { value: "week", label: "Por semana" }, { value: "month", label: "Por mês" }]} />
        {user.role === "admin" && <ExportButton kind="frequencia" start={start} end={end} />}
      </PageHeader>
      {!r ? <Empty text="Carregando…" /> : (
        <div className="space-y-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Kpi testid="att-total" label="Check-ins" value={r.total} />
            <Kpi testid="att-unique" label="Alunos distintos" value={r.unique_students} />
            <Kpi testid="att-avg" label="Média por período" value={r.series.length ? Math.round(r.total / r.series.length) : 0} />
            <Kpi testid="att-absent" label="Deixando de treinar" value={r.absent.length} tone="red" />
          </div>
          <div className="panel p-5"><div className="h-64" data-testid="att-chart">
            <ResponsiveContainer><BarChart data={r.series}><CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis dataKey="bucket" tickFormatter={(b) => (group === "month" ? b : dt(b).slice(0, 5))} /><YAxis width={30} /><Tooltip />
              <Bar dataKey="count" name="Check-ins" fill="#DC2626" radius={[3, 3, 0, 0]} /></BarChart></ResponsiveContainer></div></div>
          <div className="grid lg:grid-cols-3 gap-4">
            <div className="panel"><div className="p-4 font-display text-lg font-bold uppercase">Presentes por aula</div>
              <Table testid="att-by-class"><thead><tr><Th>Turma</Th><Th>Aulas</Th><Th>Total</Th><Th>Média</Th></tr></thead>
                <tbody>{r.by_class.map((c) => <Tr key={c.class_name}><Td className="font-semibold">{c.class_name}</Td><Td>{c.sessions}</Td><Td>{c.count}</Td><Td>{c.avg}</Td></Tr>)}</tbody></Table></div>
            <div className="panel"><div className="p-4 font-display text-lg font-bold uppercase">Mais frequentes</div>
              <div className="divide-y divide-slate-100 px-4 pb-3" data-testid="att-top">{r.top.map((s, i) => (
                <Link to={`/admin/alunos/${s.student_id}`} key={s.student_id} className="flex items-center justify-between py-2 text-sm">
                  <span><b className="text-red-600 mr-2">{i + 1}</b>{s.full_name}</span><span className="flex items-center gap-2"><Belt belt={s.belt} size="sm" /><b>{s.count}</b></span></Link>))}</div></div>
            <div className="panel"><div className="p-4 font-display text-lg font-bold uppercase">Deixando de treinar</div>
              <div className="divide-y divide-slate-100 px-4 pb-3 max-h-96 overflow-y-auto" data-testid="att-absent-list">{r.absent.length ? r.absent.map((s) => (
                <Link to={`/admin/alunos/${s.id}`} key={s.id} className="flex items-center justify-between py-2 text-sm">
                  <span>{s.full_name}<div className="text-xs text-slate-500">último: {dt(s.last_checkin)}</div></span><b className="text-red-600">{s.days_since}d</b></Link>)) : <Empty />}</div></div>
          </div>
        </div>)}
    </div>
  );
}
